export default __webpack_public_path__ + "static/media/supports.403fafb0.svg";